import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export const NewsHeader: React.FC = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="px-4 sm:px-8 lg:px-16 xl:px-24 pt-24 pb-8">
        <div className="flex items-center gap-2">
          <Link
            to="/"
            className="text-gray-500 hover:text-gray-700 transition-colors"
            style={{
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: 400
            }}
          >
            Home
          </Link>
          <ChevronRight className="w-4 h-4 text-gray-400" />
          <span
            className="text-gray-700"
            style={{
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: 500
            }}
          >
            News
          </span>
        </div>
      </div>

      {/* Header Section */}
      <div className="px-4 sm:px-8 lg:px-16 xl:px-24 pb-12">
        <h1
          className="mb-6"
          style={{
            fontFamily: 'Poppins',
            fontSize: '48px',
            fontWeight: 700,
            lineHeight: '56px',
            color: '#000000'
          }}
        >
          Stay updated on campsite news, community stories, and AI insights.
        </h1>
        <p
          style={{
            fontFamily: 'Inter',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            color: '#667479'
          }}
        >
          Explore the latest updates on Hong Kong's campsites — from real-time alerts and park reopenings to smart monitoring breakthroughs and outdoor lifestyle tips.
        </p>
      </div>
    </>
  );
};
